import React from 'react';
import { createRoot } from 'react-dom/client';
// import { PublicClientApplication, EventType } from '@azure/msal-browser';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import { msalConfig } from './authConfig';
window.React = React;

// export const msalInstance = new PublicClientApplication(msalConfig());

// // Default to using the first account if no account is active on page load
// if (msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//   // Account selection logic is app dependent. Adjust as needed for different use cases.
//   msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
// }

// // Optional - This will update account state if a user signs in from another tab or window
// msalInstance.enableAccountStorageEvents();

// msalInstance.addEventCallback((event) => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//     const { account } = event.payload;
//     msalInstance.setActiveAccount(account);
//   }
// });


const container = document.getElementById('socialboterfly');
const root = createRoot(container); 
root.render(<App />);

serviceWorker.unregister();
